import { JFT } from "../types";

/**
 * Retrieves a JFT from the API.
 * @param monthAndDay The month and day of the JFT to retrieve
 */
export async function getJFT(monthAndDay: {
  month: number;
  day: number;
}): Promise<JFT[]> {
  const url = `https://v9xn29c137.execute-api.us-east-1.amazonaws.com/default/jft/${monthAndDay.month}-${monthAndDay.day}`;
  console.log(`fetching ${url}`);
  const response = await fetch(url);
  return response.json();
}
